import { ChangeDetectorRef, Component, Inject, Input, OnChanges, Optional, SimpleChanges } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator } from '@app/modal/state-modal/state-modal.component';
import { CustactGet, CustactService, CustactSubtaskItem } from '@app/services/custact.service';
import { ActivityStatusItem, EconomyService } from '@app/services/economy.service';

@Component({
    selector: 'tt-work-details-mobile',
    templateUrl: './work-details-mobile.component.html',
    styleUrls: ['./work-details-mobile.component.css'],
})
export class WorkDetailsMobileComponent implements OnChanges {
    @Input()
    public params?: CustactGet;

    public subtasks: CustactSubtaskItem[] = [];

    public activityStatuses: ActivityStatusItem[] = [];

    constructor(
        private custact: CustactService,
        private economy: EconomyService,
        private modal: ModalService,
        private cdr: ChangeDetectorRef,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) public navigator?: TTViewNavigator,
    ) {}

    public async onActivityStatusChanged() {
        if (!!this.params) {
            const { errorcode, errormessage } = await this.custact.updateActivityStatus({ custact_no: this.params.custact_no, actstatus_keyno: this.params.actstatus_keyno });

            if ('' + errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            }
        }
    }

    public openVideoUrl() {
        if (!!this.params?.video_url) {
            window.open(this.params.video_url);
        }
    }

    private async loadSubtasks() {
        if (!!this.params && typeof this.params === 'object' && 'custact_no' in this.params && !isNaN(+this.params.custact_no) && this.params.show_next_activity === '1') {
            this.subtasks = await this.custact.getSubtasks({ custact_no: this.params.custact_no, retrievetype: 'child', include_top: '0' });
            this.cdr.markForCheck();
        }
    }

    private async loadActivityStatuses() {
        if (!!this.params && typeof this.params === 'object' && 'activitytype_no' in this.params && !isNaN(+this.params.activitytype_no)) {
            this.activityStatuses = await this.economy.getActivityStatuses({ activitytype_no: this.params.activitytype_no });
            this.cdr.markForCheck();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']) {
            this.loadSubtasks();
            this.loadActivityStatuses();
        }
    }
}
